var Division, cllCookie, decodeAddress, geoStorageKey, getFullAddressFromSearchLocCookie, getGeolocationData, getInitialGeolocationAddress, getInitialLocation, getInitialLocationData, getSearchLocCookie, getTranslations, getUserSearchLocData, presentAddress, removeGeolocationData, setELLCookie, setGeolocationData, setSearchLocCookie, userFriendlyLocation,
  slice = [].slice;

getTranslations = require('./m_typeahead_helper').getTranslations;

geoStorageKey = 'LS_geolocation';

Division = (function(currentDivision) {
  return {
    get: function() {
      return currentDivision;
    },
    set: function(division) {
      return currentDivision = division;
    }
  };
})(null);


/**
 * Get decoded address
 *
 * @param   {String} [address] - Encoded address string
 * @returns {String}           - Key value or empty object
 */

decodeAddress = function(address) {
  if (address == null) {
    address = '';
  }
  return decodeURIComponent(address).replace(/\+/g, ' ');
};


/**
 * Retrieve geolocation data from localStorage
 *
 * @param   {String}        [key] - Key name (optional)
 * @returns {String|Object} data  - Geodata object or specific data
 */

getGeolocationData = function(key) {
  var data, ref;
  try {
    if ((data = (ref = window.localStorage) != null ? ref.getItem(geoStorageKey) : void 0) != null) {
      data = JSON.parse(data);
      if (typeof key === 'string') {
        data = data[key];
      }
    }
  } catch (error) {}
  return data || {};
};


/**
 * Retrieve location name from various sources
 *
 * @returns {String} location - Location name or empty string
 */

getInitialLocation = function() {
  var division, divisionData, location;
  divisionData = Division != null ? Division.get() : void 0;
  division = divisionData != null ? divisionData.id : void 0;
  if ((location = getInitialGeolocationAddress(division))) {
    return location;
  }
  if ((location = getFullAddressFromSearchLocCookie())) {
    return location;
  }
  if ((location = userFriendlyLocation(divisionData))) {
    return location;
  }
  return '';
};


/**
 * Get location data
 *
 * @returns {Object} latLong - Location object
 */

getInitialLocationData = function() {
  var geoData, grab, latLong, locationData, queryParams;
  grab = function() {
    var data, i, j, len, properties, source, sources;
    sources = 2 <= arguments.length ? slice.call(arguments, 0, i = arguments.length - 1) : (i = 0, []), properties = arguments[i++];
    for (j = 0, len = sources.length; j < len; j++) {
      source = sources[j];
      data = _.pick(source || {}, properties);
      if (!_.isEmpty(data)) {
        break;
      }
    }
    return data;
  };
  queryParams = Groupon.Utils.unparam();
  locationData = getUserSearchLocData();
  latLong = grab(queryParams, locationData, Division.get(), ['lat', 'lng']);
  geoData = grab(queryParams, locationData, ['administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code']);
  return latLong = _.extend(latLong, geoData);
};


/**
 * Get "search_loc" cookie data
 *
 * @returns {Object} - search_loc - Search_loc data
 */

getSearchLocCookie = function() {
  var e, payload, search_loc;
  search_loc = {};
  if ((payload = Cookie.get('search_loc')) != null) {
    try {
      search_loc = JSON.parse(decodeURIComponent(payload));
    } catch (error) {
      e = error;
      try {
        search_loc = decodeURIComponent(JSON.parse(payload));
      } catch (error) {}
    }
  }
  return search_loc;
};


/**
 * Retrieve address from "search_loc" cookie
 *
 * @returns {String} - Address or empty string
 */

getFullAddressFromSearchLocCookie = function() {
  var friendlyName, fullAddress, ref;
  ref = getSearchLocCookie(), fullAddress = ref.fullAddress, friendlyName = ref.friendlyName;
  return decodeAddress(fullAddress) || decodeAddress(friendlyName);
};


/**
 * Retrieve data from "search_loc" cookie
 *
 * @returns {Object} - Relevant location data
 */

getUserSearchLocData = function() {
  var search_loc;
  search_loc = getSearchLocCookie();
  return _.pick(search_loc, ['lat', 'lng', 'administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code']);
};


/**
 * Returns current location label if division match current location division
 *
 * @param   {String} division - Division from itier division data
 * @returns {String} label    - Current location label or undefined
 */

getInitialGeolocationAddress = function(division) {
  var label, ref;
  label = '';
  if (division && division === getGeolocationData('current_location')['closestDivision']) {
    label = (ref = getTranslations('search')) != null ? ref.nearme : void 0;
  }
  return label;
};


/**
 * Changes address to remove duplicate address sections and country "USA"
 *
 * @param   {String} address - Address returned by Google Maps
 * @returns {String}         - Formatted address
 */

presentAddress = function(address) {
  var splitAddress;
  address = address.replace(/, USA$/, '');
  splitAddress = address.split(', ');
  return _.uniq(splitAddress, true).join(', ');
};


/**
 * Removes geolocation key from localStorage / cookie
 *
 * @param {String} key - LocalStorage key name
 */

removeGeolocationData = function(key) {
  var data, ref;
  if (key != null) {
    data = getGeolocationData();
    delete data[key];
    data = JSON.stringify(data);
    try {
      if ((ref = window.localStorage) != null) {
        ref.setItem(geoStorageKey, data);
      }
    } catch (error) {
      Cookie.set(geoStorageKey, encodeURIComponent(data));
    }
  }
};


/**
 * LS-2274 Set new location cookie "ell"
 *
 * @param {String} data - String contain <lat>,<lng>
 */

setELLCookie = function(data) {
  Cookie.set('ell', data);
};


/*
 * LS-2273 current location cookie "cll"
 */

cllCookie = {

  /**
   * LS-2273 Set new current location cookie "cll"
   *
   * @param {Object} location - Object containing coordinates
   */
  set: function(location) {
    var lat, lng, ref;
    if (!(location != null ? location.coords : void 0)) {
      return;
    }
    ref = location.coords, lat = ref.latitude, lng = ref.longitude;
    Cookie.set('cll', lat + ',' + lng);
  },

  /*
   * LS-2273 remove current location cookie "cll"
   */
  remove: function() {
    return Cookie.unset('cll');
  }
};


/**
 * Sets geolocation key/value pair to localStorage / cookie
 *
 * @param {String} key   - LocalStorage key name
 * @param {String} value - Value to be set
 */

setGeolocationData = function(key, value) {
  var data, ref;
  if ((key != null) && (value != null)) {
    data = getGeolocationData();
    data[key] = value;
    try {
      if ((ref = window.localStorage) != null) {
        ref.setItem(geoStorageKey, JSON.stringify(data));
      }
    } catch (error) {}
  }
};


/**
 * Sets "search_loc" cookie storing various data gathered from Gmaps and API responses
 *
 * @param {Object} data - Location data object
 */

setSearchLocCookie = function(data) {
  data = _.pick(data, ['lat', 'lng', 'closestDivision', 'friendlyName', 'fullAddress', 'administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code']);
  Cookie.set('search_loc', encodeURIComponent(JSON.stringify(data)));
};


/**
 * Returns Division Name
 *
 * @param   {Object} division - Division from itier division data
 * @returns {String} name     - Division name
 */

userFriendlyLocation = function(division) {
  var abbreviation, name, state;
  if (!(division != null ? division.name : void 0)) {
    return '';
  }
  name = division.name, state = division.state;
  if (abbreviation = state != null ? state.abbreviation : void 0) {
    name = name + ", " + abbreviation;
  }
  return name;
};

module.exports = {
  cllCookie: cllCookie,
  decodeAddress: decodeAddress,
  getDivision: Division.get,
  getGeolocationData: getGeolocationData,
  getFullAddressFromSearchLocCookie: getFullAddressFromSearchLocCookie,
  getInitialGeolocationAddress: getInitialGeolocationAddress,
  getInitialLocation: getInitialLocation,
  getInitialLocationData: getInitialLocationData,
  getSearchLocCookie: getSearchLocCookie,
  getUserSearchLocData: getUserSearchLocData,
  presentAddress: presentAddress,
  removeGeolocationData: removeGeolocationData,
  setELLCookie: setELLCookie,
  setDivision: Division.set,
  setGeolocationData: setGeolocationData,
  setSearchLocCookie: setSearchLocCookie,
  userFriendlyLocation: userFriendlyLocation
};

